/** Normalize KolayCAR / broker vehicle payload fields for UI */

const FALLBACK_IMG =
  'https://images.unsplash.com/photo-1485291571150-772bcfc10da5?w=600';

export function vehicleImageUrl(v) {
  if (!v) return FALLBACK_IMG;
  const fromArr = (arr) => {
    if (!Array.isArray(arr) || !arr.length) return null;
    const first = arr[0];
    if (typeof first === 'string') return first;
    return first?.url || first?.Url || first?.imageUrl || null;
  };
  return (
    fromArr(v.vehicleImages) ||
    fromArr(v.images) ||
    v.imageUrl ||
    v.vehicleImageURL ||
    v.vehicleImage ||
    v.image ||
    v.vehicleCategoryImagePath ||
    FALLBACK_IMG
  );
}

export function vehicleToken(v) {
  return v?.reservationToken || v?.reservation_token || v?.token || null;
}

export function vehicleVendorName(v) {
  return (
    v?.specialVendorName ||
    v?.vendorName ||
    v?.companyName ||
    (v?.baseVendorId != null ? `Vendor #${v.baseVendorId}` : null)
  );
}

export function vehicleVendorLogo(v) {
  return v?.specialVendorLogo || v?.vendorLogo || null;
}

export function vehicleSeatsLabel(v) {
  return (
    v?.passangerQuantityName ||
    v?.passengerQuantityName ||
    (v?.seats != null ? String(v.seats) : null) ||
    (v?.passengerCount != null ? String(v.passengerCount) : null)
  );
}

export function vehicleTransmissionLabel(v) {
  return (
    v?.transmissionTypeName ||
    v?.transmission ||
    (v?.transmissionType != null ? String(v.transmissionType) : null)
  );
}

export function vehicleFuelLabel(v) {
  const name = v?.fuelTypeName || v?.fuel;
  if (!name || String(name).toLowerCase().includes('tanımlanmamış')) {
    return null;
  }
  return name;
}

export function vehicleCategoryLabel(v) {
  return v?.vehicleCategoryTypeName || v?.category || null;
}

export function vehicleTypeLabel(v) {
  return v?.vehicleTypeName || null;
}

export function vehicleConditions(v) {
  const list = v?.rentalConditions;
  if (!Array.isArray(list)) return [];
  return [...list].sort(
    (a, b) => (a.conditionSequence || 0) - (b.conditionSequence || 0)
  );
}

export function toBookingVehicleSnapshot(vehicle, currency) {
  return {
    reservationToken: vehicleToken(vehicle),
    vehicleName: vehicle.vehicleName,
    vehicleDescription: vehicle.vehicleDescription,
    sippCode: vehicle.sippCode,
    vendorName: vehicleVendorName(vehicle),
    imageUrl: vehicleImageUrl(vehicle),
    dailyPrice: Number(vehicle.dailyPrice || 0),
    totalPrice: Number(vehicle.totalPrice || 0),
    supplier_dailyPrice:
      vehicle.supplier_dailyPrice != null
        ? Number(vehicle.supplier_dailyPrice)
        : undefined,
    supplier_totalPrice:
      vehicle.supplier_totalPrice != null
        ? Number(vehicle.supplier_totalPrice)
        : undefined,
    currencyCode: vehicle.currencyCode || currency || 'EUR',
    rentalDuration: vehicle.rentalDuration,
    transmission: vehicleTransmissionLabel(vehicle),
    fuelType: vehicleFuelLabel(vehicle) || vehicle.fuelTypeName,
    seats: vehicle.passangerQuantityType ?? vehicle.seats ?? null,
    raw: vehicle,
  };
}
